/* eslint-disable no-return-await */
import React, { useRef } from 'react'
import AnnounceKit from 'announcekit-react'
import MailIcon from 'mdi-react/MailIcon'
import { compose } from 'redux'
import { createStructuredSelector } from 'reselect'
import { connect } from 'react-redux'
import { Mobile, Desktop } from 'Shared/components/Responsive'
import { getUser, getIsArtist } from 'Redux/selectors/auth'
import { User } from 'Types/index'

const TopbarNotification = ({
  user,
  isArtist,
}: {
  user: User
  isArtist: boolean
}) => {
  const ref = useRef<AnnounceKit>()

  return (
    <div className="topbar__collapse">
      <div className="topbar__btn topbar__message topbar__btn--new">
        <button
          className="announcekit-widget"
          style={{
            color: 'white',
            backgroundColor: 'transparent',
            fontSize: '14px',
          }}
          type="button"
          onClick={async () => {
            ref.current && (await ref.current.open())
          }}
        >
          <MailIcon />
        </button>
        <Mobile>
          <AnnounceKit
            // @ts-ignore
            ref={ref}
            widget="https://announcekit.app/widgets/v2/3peRmo"
            user={{ id: user.email }}
            widgetStyle={{
              top: '12px',
              right: '10px',
              width: '14px',
              height: '14px',
            }}
            data={{ member_type: isArtist }}
          />
        </Mobile>
        <Desktop>
          <AnnounceKit
            // @ts-ignore
            ref={ref}
            widget="https://announcekit.app/widgets/v2/3peRmo"
            user={{ id: user.email }}
            widgetStyle={{
              top: '12px',
              right: '3px',
              width: '14px',
              height: '14px',
            }}
            data={{ member_type: isArtist }}
          />
        </Desktop>
      </div>
    </div>
  )
}

const selector = createStructuredSelector({
  // @ts-ignore
  user: getUser,
  isArtist: getIsArtist,
})

export default compose(connect(selector, null))(TopbarNotification)
